<template lang="html">
  <div class="wrapper">
    <load-spinner v-if="showSpinner"></load-spinner>
    <b-modal ref="req-result">
      <p class="my-4"
         v-bind:class="{ 'message-success' : this.reqSuccess, 'message-fail': !this.reqSuccess } ">{{
          reqResult
        }}</p>
    </b-modal>

    <div>
      <div class="poll">
        <div class="messages">
          <b-form-textarea
              id="msg-en"
              v-model="message['en']"
              placeholder="Message in english"
              rows="3"
              :state="message['en'].length > 0"
              max-rows="6"
          ></b-form-textarea>
          <b-form-textarea
              id="msg-ru"
              v-model="message['ru']"
              placeholder="Сообщение на русском"
              rows="3"
              :state="message['ru'].length > 0"
              max-rows="6"
          ></b-form-textarea>
          <b-form-textarea
              id="msg-ua"
              v-model="message['ua']"
              placeholder="Повідомлення українською"
              rows="3"
              :state="message['ua'].length > 0"
              max-rows="6"
          ></b-form-textarea>
        </div>
        <div class="poll-buttons">
          <div class="button">
            <b-form-input v-model="button1['en']" :state="buttonIsInvalid(button1)"
                          placeholder="Button text (english)"></b-form-input>
            <b-form-input v-model="button1['ru']" :state="buttonIsInvalid(button1)"
                          placeholder="Текст кнопки (русский)"></b-form-input>
            <b-form-input v-model="button1['ua']" :state="buttonIsInvalid(button1)"
                          placeholder="Текст кнопки (українською)"></b-form-input>
          </div>
          <div class="button">
            <b-form-input v-model="button2['en']" :state="buttonIsInvalid(button2)"
                          placeholder="Button text (english)"></b-form-input>
            <b-form-input v-model="button2['ru']" :state="buttonIsInvalid(button2)"
                          placeholder="Текст кнопки (русский)"></b-form-input>
            <b-form-input v-model="button2['ua']" :state="buttonIsInvalid(button2)"
                          placeholder="Текст кнопки (українською)"></b-form-input>
          </div>
        </div>
        <div class="link">
          <b-form-input v-model="link" placeholder="Посилання на зображення"></b-form-input>
        </div>
        <div class="link">
          <b-checkbox v-model="sendPriceList">Надіслати ціни</b-checkbox>
        </div>
        <div class="buttons">
          <b-button variant="success" :disabled="formIsInvalid()" @click="sendNotification">Надіслати</b-button>
        </div>
        <p id="listeners">Користувачів вибрано {{ listeners.length }}</p>
      </div>
      <b-tabs content-class="mt-3">
        <b-tab title="Вибір користувачів" active lazy class="user-pick" @click="pickWithHand">
          <div class="list">
            <b-pagination
                align="center"
                v-model="currentPageAll"
                :total-rows="length"
                :per-page="perPageAll"
                aria-controls="all"
                @change="nextPageAll"
            ></b-pagination>
            <b-table
                @row-clicked="addClientToPicked"
                :tbody-tr-class="itemIsPicked"

                :hover="true"
                v-if="!reload"
                id="all"
                :items="this.items"
                :fields="this.fieldsAll"
                striped responsive="sm"
                :current-page="currentPageAll"
                :per-page="perPageAll"></b-table>
          </div>
          <div class="picked">
            <p class="heading">Вибрані користувачі</p>
            <b-table
                @row-clicked="addClientToAll"
                v-if="!reload"
                id="picked"
                :items="this.picked"
                :fields="this.fieldsPicked"
                striped responsive="sm"
                :per-page="perPagePicked"></b-table>
          </div>
        </b-tab>
        <b-tab title="По регіону" lazy @click="pickWithRegions">
          <b-form-checkbox
              v-for="region in regions" :key="region.id"
              :id="'region-' + region.id"
              v-model="region.picked"
              name="checkbox-1"
              @input="getRegionListeners"
          >
            {{ region['uaShort'] }}
          </b-form-checkbox>
        </b-tab>
        <b-tab title="По менеджеру" lazy @click="pickWithManagers">
          <b-form-checkbox
              v-for="manager in managers" :key="manager.id"
              :id="'manager-' + manager.id"
              v-model="manager.picked"
              name="checkbox-1"
              @input="getManagerListeners"
          >
            {{ manager['name'] }}
          </b-form-checkbox>
        </b-tab>
        <b-tab title="Із замовленням" lazy @click="pickWithOrders">
          <p>Вибрані усі клієнти, що зробили замовлення через бота. Усього: {{ listeners.length }}</p>
        </b-tab>
        <b-tab title="Із об'ємом" lazy @click="pickWithVolume">
          <b-form-checkbox
              v-for="volume in volumes" :key="volume.volume"
              :id="'volume-' + volume.volume"
              v-model="volume.picked"
              name="checkbox-1"
              @input="getVolumeListeners"
          >
            {{ volume['volume'] }}
          </b-form-checkbox>
        </b-tab>


        <b-tab title="Всі" lazy @click="pickAll">
          Вибрані усі клієнти, що користувались ботом у вайбері.
        </b-tab>

      </b-tabs>
    </div>
  </div>
</template>

<script lang="js">
import LoadSpinner from '../components/LoadSpinner';
import {
  getAllClients,
  getListenersChunk,
  getListenersWithOrders,
  getManagerListeners,
  getRegionListeners, getVolumeListeners,
  getVolumesList
} from "@/services/Clients.service";
import {getRegions} from "@/services/Regions.service";
import {getManagersList} from "@/services/Managers.service";
import {sendNotification} from "@/services/Notifications.service";

export default {
  name: 'src-components-notifications',
  props: [],
  components: {LoadSpinner},
  mounted() {
    this.getChunk();
  },
  data() {
    return {
      reqSuccess: true,
      reqResult: '',
      showSpinner: false,
      listeners: [],
      message: {
        en: '',
        ru: '',
        ua: '',
      },
      button1: {
        en: '',
        ru: '',
        ua: '',
      },
      button2: {
        en: '',
        ru: '',
        ua: '',
      },
      link: '',
      sendPriceList: false,

      // Listeners from: Pick clients from table
      currentPageAll: 1,
      perPageAll: 15,
      items: [],
      length: 0,
      fieldsAll: ['id', 'Ім\'я', 'Компанія', 'ЕДРПОУ'],
      reload: true,
      currentPagePicked: 1,
      perPagePicked: 50,
      picked: [],
      lengthPicked: 50,
      fieldsPicked: ['Ім\'я', 'Компанія', 'ЕДРПОУ'],

      // Listeners from: Region
      regions: [],
      regionListeners: [],

      // Listeners from: Managers
      managers: [],
      managerListeners: [],

      // Listeners from: withOrders
      withOrdersListeners: [],

      // Listeners from: volume from CRM
      volumes: [],
      volumeListeners: [],
    }
  },
  methods: {
    showModal() {
      this.$refs['req-result'].show();
      setTimeout(() => {
        this.$refs['req-result'].hide();
      }, 2000);
    },
    sendNotification() {
      this.showSpiner = true;
      const ids = this.listeners.map(l => l.id);
      const buttons = [];

      if (this.buttonIsInvalid(this.button1)) {
        buttons.push(this.button1);
      }
      if (this.buttonIsInvalid(this.button2)) {
        buttons.push(this.button2);
      }
      sendNotification(ids, this.link, this.message, buttons, this.sendPriceList)
          .then(() => {
            this.showSpiner = false;
            this.reqResult = 'Розсилка виконана';
            this.reqSuccess = true;
            this.showModal();
          })
          .catch(() => {
            this.showSpiner = false;
            this.reqResult = 'Трапилася помилка на сервері, зверніться до адміністратора';
            this.reqSuccess = false;
            this.showModal();
          });
    },

    // Listeners from: Pick clients from table
    pickWithHand() {
      this.clearVariables();
      this.getChunk();
    },
    getChunk() {
      this.showSpinner = true;
      this.reload = true;
      const offset = (this.currentPageAll - 1) * this.perPageAll;
      getListenersChunk(this.perPageAll, offset)
          .then(({identifiers, length}) => {
            this.items.length = length;
            this.length = length;
            const ids = this.items.map(i => i.id);
            for (let i = offset; i < offset + this.perPageAll && identifiers.length; i += 1) {
              if (!this.items[i]) {
                const customer = identifiers.pop();
                if (ids.indexOf(customer.id) === -1) {
                  this.items[i] = {
                    'Ім\'я': customer.name,
                    'Компанія': customer.company,
                    'ЕДРПОУ': customer.edrpou,
                    id: customer.id,
                    picked: false,
                  };
                  ids.push(identifiers.id);
                }
              }
            }
            this.reload = false;
            this.showSpinner = false;
          })
          .catch(() => {
            this.reload = false;
            this.showSpinner = false;
            this.reqResult = 'Трапилася помилка на сервері, зверніться до адміністратора';
            this.reqSuccess = false;
            this.showModal();
          });
    },
    nextPageAll(e) {
      this.currentPageAll = e;
      this.getChunk();
    },
    addClientToPicked(item) {
      this.reload = true;
      const clientId = item.id;
      const isPicked = this.picked.find(x => x.id === clientId);
      const client = this.items.filter(Boolean).find(x => x.id === clientId);

      if (!isPicked) {
        this.picked.push(client);
      } else {
        this.picked = this.picked.filter(x => x.id !== clientId);
      }
      this.reload = false;
      this.listeners = JSON.parse(JSON.stringify(this.picked));
    },
    addClientToAll(item) {
      this.reload = true;
      this.picked = this.picked.filter(x => x.id !== item.id);
      this.reload = false;
      this.listeners = JSON.parse(JSON.stringify(this.picked));
    },
    itemIsPicked(item) {
      let picked = this.picked.map(x => x.id);
      if (picked.indexOf(item.id) !== -1) {
        return 'row-picked'
      }
    },

    // Listeners from: Region
    pickWithRegions() {
      this.clearVariables();
      this.getRegions();
    },
    getRegions() {
      this.clearVariables();
      this.showSpinner = true;
      this.reload = true;
      getRegions()
          .then(({regions}) => {
            this.showSpinner = false;
            this.reload = false;
            this.regions = regions.map(r => ({...r, picked: false}));
          })
          .catch(() => {
            this.showSpinner = false;
            this.reload = false;
            this.reqResult = 'Трапилася помилка на сервері, зверніться до адміністратора';
            this.reqSuccess = false;
            this.showModal();
          })
    },
    getRegionListeners() {
      const ids = this.regions.filter(x => x.picked).map(x => x.id);
      if (ids.length === 0) {
        this.regionListeners = [];
        this.listeners = [];
        return;
      }
      this.showSpinner = true;
      getRegionListeners(ids)
          .then(({identifiers}) => {
            this.regionListeners = identifiers;
            this.listeners = identifiers.map(id => ({id}));
            this.showSpinner = false;
          })
          .catch(() => {
            this.showSpinner = false;
            this.reload = false;
            this.reqResult = 'Трапилася помилка на сервері, зверніться до адміністратора';
            this.reqSuccess = false;
            this.showModal();
          });
    },

    // Listeners from: managers
    pickWithManagers() {
      this.clearVariables();
      this.getManagers();
    },
    getManagers() {
      this.clearVariables();
      this.showSpinner = true;
      this.reload = true;
      getManagersList()
          .then(({managers}) => {
            this.showSpinner = false;
            this.reload = false;
            this.managers = managers.map(r => ({...r, picked: false}));
          })
          .catch(() => {
            this.showSpinner = false;
            this.reload = false;
            this.reqResult = 'Трапилася помилка на сервері, зверніться до адміністратора';
            this.reqSuccess = false;
            this.showModal();
          })
    },
    getManagerListeners() {
      const ids = this.managers.filter(x => x.picked).map(x => x.id);
      if (ids.length === 0) {
        this.managerListeners = [];
        this.listeners = [];
        return;
      }
      this.showSpinner = true;
      getManagerListeners(ids)
          .then(({identifiers}) => {
            this.managerListeners = identifiers;
            this.listeners = identifiers.map(id => ({id}));
            this.showSpinner = false;
          })
          .catch(() => {
            this.showSpinner = false;
            this.reload = false;
            this.reqResult = 'Трапилася помилка на сервері, зверніться до адміністратора';
            this.reqSuccess = false;
            this.showModal();
          });
    },

    // Listeners from: with orders
    pickWithOrders() {
      this.clearVariables();
      this.getListenersWithOrders();
    },
    getListenersWithOrders() {
      this.showSpinner = true;
      getListenersWithOrders()
          .then(({identifiers}) => {
            this.withOrdersListeners = identifiers;
            this.listeners = identifiers.map(id => ({id}));
            this.showSpinner = false;
          })
          .catch(() => {
            this.showSpinner = false;
            this.reload = false;
            this.reqResult = 'Трапилася помилка на сервері, зверніться до адміністратора';
            this.reqSuccess = false;
            this.showModal();
          });
    },

    // Listeners from: volume from CRM
    pickWithVolume() {
      this.clearVariables();
      this.getVolumes();
    },
    getVolumes() {
      // this.clearVariables();
      this.showSpinner = true;
      this.reload = true;
      getVolumesList()
          .then(({volumes}) => {
            this.volumes = volumes.map(volume => ({volume, picked: false}));
            this.showSpinner = false;
            this.reload = false;
          })
          .catch(() => {
            this.showSpinner = false;
            this.reload = false;
            this.reqResult = 'Трапилася помилка на сервері, зверніться до адміністратора';
            this.reqSuccess = false;
            this.showModal();
          })
    },
    getVolumeListeners() {
      const volumes = this.volumes.filter(x => x.picked).map(x => x.volume);
      if (volumes.length === 0) {
        this.volumeListeners = [];
        this.listeners = [];
        return;
      }
      this.showSpinner = true;
      getVolumeListeners(volumes)
          .then(({identifiers}) => {
            this.volumeListeners = identifiers;
            this.listeners = identifiers.map(id => ({id}));
            this.showSpinner = false;
          })
          .catch(() => {
            this.showSpinner = false;
            this.reload = false;
            this.reqResult = 'Трапилася помилка на сервері, зверніться до адміністратора';
            this.reqSuccess = false;
            this.showModal();
          });
    },

    // Pick all
    pickAll() {
      this.clearVariables();
      this.getAllClients();
    },
    getAllClients() {
      this.showSpinner = true;
      this.reload = true;
      getAllClients()
          .then(({identifiers}) => {
            this.listeners = identifiers.map(id => ({id}));
            this.showSpinner = false;
            this.reload = false;
          })
          .catch(() => {
            this.showSpinner = false;
            this.reload = false;
            this.reqResult = 'Трапилася помилка на сервері, зверніться до адміністратора';
            this.reqSuccess = false;
            this.showModal();
          })
    },


    // utils
    clearVariables() {
      this.picked = [];
      this.items = [];

      this.regionListeners = [];

      this.listeners = [];
    },
    buttonIsInvalid(btn) {
      let valid = false;
      if (btn['en'] === '' && btn['ru'] === '' && btn['ua'] === '') {
        valid = null;
      }
      if (btn['en'] !== '' && btn['ru'] !== '' && btn['ua'] !== '') {
        valid = true;
      }
      return valid;
    },
    formIsInvalid() {
      const button1Result = this.buttonIsInvalid(this.button1);
      const button2Result = this.buttonIsInvalid(this.button2);


      const button1IsValid = !(button1Result === false);
      const button2IsValid = !(button2Result === false);


      const buttonsAreInvalid = !(button1IsValid && button2IsValid);
      const messagesAreInvalid = ((this.message['en'] === '' || this.message['ua'] === '' || this.message['ru'] === '' ) && !this.sendPriceList);
          // ((!this.message['ua'] || !this.message['ru'] || !this.message['en']) && this.sendPriceList);
      // const messagesAreInvalid = (/*this.message['en'] === '' ||*/ this.message['ua'] === '' || this.message['ru'] === '');

      // console.log(buttonsAreInvalid);
      // console.log(messagesAreInvalid);
      // console.log(this.listeners.length === 0);

      return messagesAreInvalid || buttonsAreInvalid || this.listeners.length === 0;
    }
  },
  computed: {},
  watch: {}
}
</script>

<style lang="scss">
.wrapper {
  padding: 16px 32px;

  #listeners {
    margin-top: 16px;
    text-align: center;
    font-size: 24px;
  }

  .poll {
    margin-bottom: 128px;

    .messages {
      padding: 16px;
      display: flex;
      justify-content: center;

      textarea:not(:first-child) {
        margin-left: 16px;
      }

      textarea:not(:last-child) {
        margin-right: 16px;
      }
    }

    .poll-buttons {
      padding: 16px;
      display: flex;
      justify-content: center;

      .button {
        margin-left: 16px;
        margin-right: 16px;

        input {
          margin: 16px;
        }
      }

    }

    .buttons {
      display: flex;
      justify-content: center;
    }
  }

  .user-pick {
    display: flex;

    .list, .picked {
      flex: 1 1 50%;
      padding: 4px 48px;

      .row-picked {
        //background-color: #6b6666;
        opacity: 20%;
      }
    }
  }
}

.message-fail {
  color: red !important;
}

.message-success {
  color: green;
}

.link {
  display: flex;
  justify-content: center;

  input {
    width: 300px;
  }
}
</style>
